import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { PoolID } from '~src/settings/dataconnect-settings/sections/types/PoolID';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasEdgePoolError } from '../../sections/types/BaasEdgePoolError';

export interface IDeleteBaasEdgePoolParams {
  poolId: PoolID;
  clusterId: string;
}

export interface IDeleteBaasEdgePoolResult extends IResult {
  success?: {
    poolId: PoolID;
  };
  error?: BaasEdgePoolError;
}

export class DeleteBaasEdgePoolRequest extends Request<IDeleteBaasEdgePoolParams, IDeleteBaasEdgePoolResult> {
  constructor(params: IDeleteBaasEdgePoolParams) {
    super('deleteBaasEdgePool', params);
  }
}
